import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';

@Component({
  standalone: true,
  selector: 'app-car-equipment-modal',
  templateUrl: './car-equipment-modal.component.html',
  styleUrls: ['./car-equipment-modal.component.scss'],
  imports: [CommonModule, I18NextModule, MatDialogModule, MatIconModule]
})
export class CarEquipmentModalComponent {
  public penaltyAccidentIncreases: any = i18next.t('penaltyAccidentIncreases', {
    returnObjects: true
  });

  constructor(
    public dialogRef: MatDialogRef<CarEquipmentModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      equipment: any;
      theme: string;
    }
  ) {}
}
